import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';

/* Local components */
import { WheelchairComponent } from './wheelchair.component';
import { WheelchairHomeComponent } from './components/home/wheelchair-home.component';
import { WheelchairAttachedComponent } from './components/attached/wheelchair-attached.component';
import { WheelchairRankingComponent } from './components/ranking/list/wheelchair-ranking.component';
import { WheelchairRankingClassifComponent } from './components/ranking/classification/wheelchair-ranking-classif.component';
import { WheelchairRankingHistoryComponent } from './components/history/wheelchair-ranking-history.component';

/* Routes */
import { WheelchairRoutingModule } from './wheelchair-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        WheelchairComponent,
        WheelchairHomeComponent,
        WheelchairAttachedComponent,
        WheelchairRankingComponent,
        WheelchairRankingClassifComponent,
        WheelchairRankingHistoryComponent,
    ],
    imports: [CommonModule, RouterModule, WheelchairRoutingModule, ThemeModule, Interceptor],
})
export class WheelchairModule {}
